import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924 } from "@faire/web-api--source/indigofair/settings/LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

const useSettingLoggedOutHomepageV2 = (): IFourVariantXP => {
  return useSetting(
    LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924,
    IFourVariantXP.Bucket.CONTROL
  );
};

export const useIsLoggedOutHomepageV2 = () => {
  const settingHomepageV2 = useSettingLoggedOutHomepageV2();
  return settingHomepageV2 !== IFourVariantXP.Bucket.CONTROL;
};
